// extracted by mini-css-extract-plugin
module.exports = {"formText":"SubmenuPropertyForm_formText__nDPhl","list":"SubmenuPropertyForm_list__elLij","dialogContent":"SubmenuPropertyForm_dialogContent__19oo6"};